var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLicense(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 47,
    viewBox: "0 0 54 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4304 9.33294C6.34704 11.3746 5.86093 13.319 7.90259 19.0552C9.65259 23.7218 9.74982 23.819 14.222 24.1107C18.597 24.4024 18.8887 24.3052 20.6387 20.7079C23.6526 14.9718 26.1804 13.0274 29.097 14.3885C33.9581 16.6246 37.2637 25.9579 34.2498 28.9718C32.597 30.6246 26.1804 30.4302 22.7776 28.6802C20.8331 27.7079 19.7637 27.5135 19.3748 28.2913C18.9859 28.8746 17.722 29.6524 16.5554 30.0413C14.6109 30.819 14.7081 31.0135 18.4026 34.5135C25.8887 41.4163 31.722 42.8746 35.9998 38.7913C39.1109 35.8746 44.5554 26.1524 46.2081 20.7079C47.2776 17.0135 47.1804 16.3329 45.6248 14.5829C42.4165 11.0829 33.7637 8.55516 23.2637 8.06905C15.5831 7.77738 12.8609 8.06905 10.4304 9.33294Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3056 19.9298C22.9722 22.2632 23.3611 23.1382 26.9584 24.1104C30.75 25.0826 31.7222 23.1382 28.8056 20.2215C27.0556 18.4715 26.8611 18.4715 25.3056 19.9298Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicense);
export default __webpack_public_path__ + "static/media/license.890ea6e9414a09802e8bcc701c8e2e7d.svg";
export { ForwardRef as ReactComponent };